import { render, staticRenderFns } from "./IconContainers.vue?vue&type=template&id=70ad569a&scoped=true&"
import script from "./IconContainers.vue?vue&type=script&lang=js&"
export * from "./IconContainers.vue?vue&type=script&lang=js&"
import style0 from "./IconContainers.vue?vue&type=style&index=0&id=70ad569a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad569a",
  null
  
)

export default component.exports